import http from "@/utils/request";

// 品牌列表
export function brandList(data: any) {
  return http.post<Res.response<any>>({
    url: "/brand/list",
    data,
  });
}
//职员详情
export function brandUpdatePush(data: any) {
  return http.get<Res.response<any>>({
    url: "/brand/update/push?id=" + data,
  });
}
// 添加品牌
export function addBrand(data: any) {
  return http.post<Res.response<any>>({
    url: "/brand/add",
    data,
  });
}
// 修改品牌
export function brandUpdate(data: any) {
  return http.put<Res.response<any>>({
    url: "/brand/update",
    data,
  });
}
// 分类列表
export function shopgtList(data: any) {
  return http.post<Res.response<any>>({
    url: "/shopgt/list",
    data,
  });
}
// 修改列表字段
export function updateListFiled(data: any) {
  return http.post<Res.response<any>>({
    url: "/shopgt/updateListFiled",
    data,
  });
}
// 添加分类
export function addShopgt(data: any) {
  return http.post<Res.response<any>>({
    url: "/shopgt/add",
    data,
  });
}
// 修改品牌
export function shopgtUpdate(data: any) {
  return http.put<Res.response<any>>({
    url: "/shopgt/update",
    data,
  });
}
